<template>
    <div>
    </div>
</template>

<script>
  export default {
    name: 'Login',
    mounted() {
      window.location.href = 'http://142.93.249.93/login';
    },
  };
</script>